import { useId } from 'react'

export const useBetterUseId = () => {
  return useId().slice(1, -1)
}
